import { useState } from "react";
import { api, apiErr, openPdf } from "@/lib/api";
import { toast } from "sonner";
import { Printer, Mail } from "lucide-react";

// Printable PDF receipt + "Email receipt" (sent to the client's email on file) for one payment.
export function PaymentReceiptActions({ payment, onEmailed }) {
  const [sending, setSending] = useState(false);
  const view = async () => { try { await openPdf(`/payments/${payment.id}/receipt`); } catch (e) { toast.error(apiErr(e)); } };
  const email = async () => {
    if (!window.confirm("Email this receipt to the client's email address on file?")) return;
    setSending(true);
    try { const r = await api.post(`/payments/${payment.id}/email-receipt`); toast.success(`Receipt emailed to ${r.data.to}`); onEmailed?.(); }
    catch (e) { toast.error(apiErr(e)); } finally { setSending(false); }
  };
  const emailed = payment.emailed || (payment.receipt_emails || []).length > 0;
  return (
    <span className="inline-flex items-center gap-2">
      <button data-testid={`receipt-view-${payment.id}`} onClick={view} className="text-primary font-semibold text-[11px] inline-flex items-center gap-1"><Printer className="h-3.5 w-3.5" /> Receipt</button>
      <button data-testid={`receipt-email-${payment.id}`} onClick={email} disabled={sending} className="text-secondary font-semibold text-[11px] inline-flex items-center gap-1 disabled:opacity-50"><Mail className="h-3.5 w-3.5" /> {sending ? "Sending…" : emailed ? "Email again" : "Email"}</button>
    </span>
  );
}
